import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconGooglenews(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2h16v11H0V2zm9 3v1h4V5H9zm0 2v1h5V7H9zm0 2v1h4V9H9zM4.505 5A2.502 2.502 0 0 0 2 7.5C2 8.88 3.122 10 4.505 10c.901 0 1.423-.278 1.877-.73C6.835 8.816 7 8.132 7 7.441a2.7 2.7 0 0 0-.019-.313H4.535v.884h1.437c-.059.22-.158.42-.313.576-.28.279-.601.45-1.156.45A1.54 1.54 0 0 1 2.961 7.5c0-.85.69-1.54 1.542-1.54.414 0 .776.119 1.062.376l.705-.691-.001-.002C5.799 5.201 5.197 5 4.505 5z"
      />
    </Icon>
  )
}
